var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header header--auth"},[_c('div',{staticClass:"header__logo"},[_c('img',{attrs:{"src":require("@/assets/images/img_logo.png"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }